// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5ef3c15d","135":"9e64e198","143":"f92ecdb0","179":"6f7d382a","250":"a1a06abe","259":"24d1eb8b","310":"d1689a20","333":"fe0e132c","434":"76947754","592":"383c07f2","691":"9046fd64","834":"8e343c5e","846":"f52ef5bd","968":"f5b5b91b","980":"e618180d"}[chunkId] + ".chunk.js";
};